import { render, staticRenderFns } from "./approvalEntries.vue?vue&type=template&id=1019f166&scoped=true"
import script from "./approvalEntries.vue?vue&type=script&lang=js"
export * from "./approvalEntries.vue?vue&type=script&lang=js"
import style0 from "./approvalEntries.vue?vue&type=style&index=0&id=1019f166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019f166",
  null
  
)

export default component.exports